import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';
import { trackAbTestEvent } from 'dibs-tracking';

export const EXPERIMENT_NAME = 'PDP_RESP_TABS_REDESIGN';

export const trackRespTabsVariant = (): void => {
    const trackingData = getAbTestTrackingData(document.cookie, EXPERIMENT_NAME);
    trackAbTestEvent(trackingData, EXPERIMENT_NAME);
};
